import gql from 'graphql-tag';
import suggestionCandidateFragmentInAdder from '../fragments/suggestionCandidateInAdder';

export default gql`
  query searchSuggestions(
    $tenantId: ID!
    $suggestionsListId: ID!
    $query: String!
    $filters: [SuggestionSourceType!]!
  ) {
    searchSuggestions(
      tenant: $tenantId
      suggestionsListId: $suggestionsListId
      query: $query
      count: 50
      filters: $filters
    ) {
      id
      entries {
        ...suggestionCandidateInAdder
      }
    }
  }
  ${suggestionCandidateFragmentInAdder}
`;
